export default {
  serverURL: 'https://demo-server.aabvie.net'// 'http://localhost:13000' //'https://backend-aa-vie.aps-benin.com'
}
